import type { MagentoProduct } from './_graphql';

const MINDBOX_ENDPOINT = '/api/landings/mindbox';

export type LandingPriceInfo = {
	basePrice: number;
	finalPrice: number | null;
};

export async function getMindboxPrices(
	products: MagentoProduct[]
): Promise<Record<string, LandingPriceInfo>> {
	const items = products
		.map((product) => {
			const mindboxId = product.mindbox_id;
			const basePrice = product.price?.maximum_price?.final_price?.value;

			if (!mindboxId || !basePrice) {
				return null;
			}

			return {
				sku: product.sku,
				mindboxId,
				basePrice,
				specialPrice: product.special_price
			};
		})
		.filter((item): item is NonNullable<typeof item> => item !== null);

	if (!items.length) {
		return {};
	}

	const response = await fetch(MINDBOX_ENDPOINT, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		credentials: 'include',
		body: JSON.stringify({ items })
	});

	if (!response.ok) {
		return {};
	}

	return response.json();
}
